import {useEffect, useState} from 'react';
import {Button, Form, Modal} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {DhcpLease} from '../../Types/routerForms';
import {IP_REGEX, MAC_REGEX, newLocalId} from '../../Utils/random';

interface AddDhcpLeaseModalProps {
  show: boolean;
  onHide: () => void;
  onAdd: (lease: DhcpLease) => void;
}

const AddDhcpLeaseModal = ({show, onHide, onAdd}: AddDhcpLeaseModalProps): JSX.Element => {
  const intl = useIntl();
  const [ip, setIp] = useState('');
  const [mac, setMac] = useState('');
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    if (show) {
      setIp('');
      setMac('');
      setValidated(false);
    }
  }, [show]);

  const isIpValid = IP_REGEX.test(ip);
  const isMacValid = MAC_REGEX.test(mac);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setValidated(true);
    if (!isIpValid || !isMacValid) return;
    onAdd({id: newLocalId('lease'), ip, mac, reserved: true});
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.LEASES.ADD'})}
        </Modal.Title>
      </Modal.Header>
      <Form noValidate validated={validated} onSubmit={handleSubmit} id="addLeaseForm">
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label className="required">
              {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.LEASES.IP'})}
            </Form.Label>
            <Form.Control
              type="text"
              value={ip}
              onChange={(e) => setIp(e.target.value)}
              placeholder="192.168.1.50"
              isInvalid={validated && !isIpValid}
              required
            />
            <Form.Control.Feedback type="invalid">
              {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VALIDATION.IP'})}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group>
            <Form.Label className="required">
              {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.LEASES.MAC'})}
            </Form.Label>
            <Form.Control
              type="text"
              value={mac}
              onChange={(e) => setMac(e.target.value)}
              placeholder="AA:BB:CC:DD:EE:FF"
              isInvalid={validated && !isMacValid}
              required
            />
            <Form.Control.Feedback type="invalid">
              {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VALIDATION.MAC'})}
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {intl.formatMessage({id: 'COMMON.CANCEL'})}
          </Button>
          <Button variant="primary" type="submit" form="addLeaseForm">
            {intl.formatMessage({id: 'COMMON.ADD'})}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddDhcpLeaseModal;
